import { localStorageConst } from "../constants";
import { DateShortcutEnum } from "./DateFilterShortcutButtonEnum";

window.jsUcfirst = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

const _domHighlightTimers = new WeakMap()
export const scrollIntoView = (domElement, {errorHint = "This field cannot be blank", scrollType = 'simple', autoHighlight = true,  highlightTimer = 2500} = {}) => {
    if (!domElement || !(domElement instanceof Element || element instanceof HTMLDocument)) {
        return
    }
    if (scrollType == 'simple') {
        // Scroll to the element
        domElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

        // UI highlight with throttling, multiple spams will not reset timer
        if (autoHighlight) {
            const timerExist = _domHighlightTimers.get(domElement)
            if (!timerExist) {
                highlightTimer = highlightTimer && highlightTimer > 200 ? highlightTimer : 200
                const $domElement = $(domElement)
                $domElement.addClass('temp-error-highlight')

                let errorDiv = null
                if (errorHint) {
                    let position = $domElement.position()
                    errorDiv = $(`<div class="temp-error-hint" style="position: absolute; left: ${position.left}px; top: ${position.top + $domElement.outerHeight() + 5}px"><i>* ${errorHint}</i></div>`).appendTo($domElement.parent())
                }

                _domHighlightTimers.set(domElement, setTimeout(() => {
                    $domElement.removeClass('temp-error-highlight')
                    _domHighlightTimers.delete(domElement)
                    errorDiv && errorDiv.remove()
                }, highlightTimer))
            }
        }
    }
    else {
        var headerOffset = 45;
        var elementPosition = domElement.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
}
export const isNullOrBlank = (str) => {
    return str === null || str === "" || str === undefined
}
export const isObject = (obj) => {
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null
}
export const isFunction = (obj) => {
    return typeof obj === 'function'
}
export const copyToClipboard = (text) => {
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = text
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
}
// https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
export const getDeviceDetail = () => {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "OPR" or after "Version"
    if ((verOffset = nAgt.indexOf("OPR")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
            fullVersion = nAgt.substring(verOffset + 8);
        }
    }
    // In MS Edge, the true version is after "Edg" in userAgent
    else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
        browserName = "Microsoft Edge";
        fullVersion = nAgt.substring(verOffset + 4);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome" 
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version" 
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
            fullVersion = nAgt.substring(verOffset + 8);
        }
    }
    // In Firefox, the true version is after "Firefox" 
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent 
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) != -1) {
        fullVersion = fullVersion.substring(0, ix);
    }
    if ((ix = fullVersion.indexOf(" ")) != -1) {
        fullVersion = fullVersion.substring(0, ix);
    }

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    return {
        browserName: browserName,
        fullVersion: fullVersion,
        majorVersion: majorVersion,
        appName: navigator.appName,
        userAgent: navigator.userAgent,
        appVersion: navigator.appVersion,
    }
}

export const getOrderlahDeviceId = () => {
    let deviceId = localStorage.getItem(localStorageConst.LOCAL_STORAGE_ORDERLAH_DEVICE_ID)
    if (!deviceId) {
        const rand = Math.ceil(Math.random() * 100000)
        deviceId = `${window.merchant_id}-${moment().unix()}-${rand}`
        localStorage.setItem(localStorageConst.LOCAL_STORAGE_ORDERLAH_DEVICE_ID, deviceId)
    }
    return deviceId
}
/**
 * @param {String} url
 * @returns
 */
export const isFullUrl = (url) => {
    return url && url.substr(0,4) == 'http'
}

/**
 * @param {String} url
 * @returns
 */
export const getImageFullUrl = (imgUrl) => {
    if (imgUrl && imgUrl.substr(0, 9) == '/storage/') {
        imgUrl = imgUrl.substr(9)
    }
    imgUrl = base_image_url + imgUrl
    return imgUrl
}

const EXCEL_BOLD = 2

function DatatableHelper() {

    this.getStartEndDate = ({startDate, endDate, dateRangeShortcut}) => {
        const dateFormat = 'YYYY-MM-DD'
        const { start, end, } = this.getDateRangeByShortcut(dateRangeShortcut)
        let startDateStr = ""
        let endDateStr = ""
        let startDateTimeStr = ""
        let endDateTimeStr = ""
        let shortcutStartDateStr = ""
        let shortcutEndDateStr = ""
        let shortcutStartDateTimeStr = ""
        let shortcutEndDateTimeStr = ""

        if (startDate && endDate) {
            // startDateTimeStr = startDate.format('YYYY-MM-DD 00:00:00')
            // endDateTimeStr = endDate.format('YYYY-MM-DD 23:59:59')
            // startDateStr = startDate.format(dateFormat)
            // endDateStr = endDate.format(dateFormat)
        }
        else if (dateRangeShortcut) {
            // Start and end by shortcut
            shortcutStartDateStr = start && start.format(dateFormat) || ""
            shortcutEndDateStr = end && end.format(dateFormat) || ""

            shortcutStartDateTimeStr = start && start.format('YYYY-MM-DD 00:00:00') || ""
            shortcutEndDateTimeStr = end && end.format('YYYY-MM-DD 23:59:59') || ""

            startDate   = start
            endDate     = end
        }

        startDateStr = startDate && startDate.format(dateFormat)
        endDateStr = endDate && endDate.format(dateFormat)
        startDateTimeStr = startDate && startDate.format('YYYY-MM-DD 00:00:00')
        endDateTimeStr = endDate && endDate.format('YYYY-MM-DD 23:59:59')

        return { startDate, endDate, startDateStr, endDateStr, startDateTimeStr, endDateTimeStr, shortcutStartDateStr, shortcutEndDateStr, shortcutEndDateTimeStr }
    }

    this.getDateRangeByShortcut = (dateRangeShortcut) => {
        const now = moment()
        let start = null
        let end = null
        switch (dateRangeShortcut) {
            case DateShortcutEnum.PREORDER:
                start = now.clone().add(1, 'day').startOf('day')
                end = null
                break;
            case DateShortcutEnum.TODAY:
                start = now.clone().startOf('day')
                end = now.clone().endOf('day')
                break;
            case DateShortcutEnum.YESTERDAY:
                const yesterday = now.clone().add(-1, 'days')
                start = yesterday.clone().startOf('day')
                end = yesterday.clone().endOf('day')
                break;
            case DateShortcutEnum.THIS_WEEK:
                start = now.clone().startOf('isoWeek')
                end = now.clone().endOf('isoWeek')
                break;
            case DateShortcutEnum.LAST_WEEK:
                start = now.clone().add(-1, 'week').startOf('isoWeek')
                end = now.clone().add(-1, 'week').endOf('isoWeek')
                break
            case DateShortcutEnum.THIS_MONTH:
                start = now.clone().startOf('month')
                end = now.clone().endOf('month')
                break
            case DateShortcutEnum.LAST_MONTH:
                start = now.clone().add(-1, 'month').startOf('month')
                end = now.clone().add(-1, 'month').endOf('month')
                break
            case DateShortcutEnum.PREORDER:
                start = now.clone().add(1, 'days').startOf('day');
                break
            case DateShortcutEnum.THIS_YEAR:
                start = now.clone().startOf('year')
                end = now.clone().endOf('day')
                break
            case DateShortcutEnum.LAST_YEAR:
                start = now.clone().add(-1, 'year').startOf('year')
                end = now.clone().add(-1, 'year').endOf('year')
                break
            default:
        }
        return { start, end, }
    }

    this.excelCustomizeAddReportInfo = ({merchantName, reportType, dateRange}) => {
        return {
            footer: true,

            // Remove title from top of table
            title: '',
            customize: (xlsx) => {
                const rowsToAdd = []
                let rowIndex = 1
                if (merchantName) {
                    rowsToAdd.push({
                        rowIndex: rowIndex++,
                        rowData: [{ k: 'A', v: 'Company Name', 's': EXCEL_BOLD }, { k: 'B', v: typeof merchantName === 'function' ? merchantName() : merchantName }],
                    })
                }
                rowsToAdd.push({
                    rowIndex: rowIndex++,
                    rowData: [{ k: 'A', v: 'Date/Time', 's': EXCEL_BOLD }, { k: 'B', v: moment().format('YYYY-MM-DD hh:mm a') }],
                })
                if (dateRange && dateRange.startDate && typeof dateRange.startDate === 'function' && dateRange.startDate() && dateRange.endDate && typeof dateRange.endDate === 'function' && dateRange.endDate()) {
                    rowsToAdd.push({
                        rowIndex: rowIndex++,
                        rowData: [{ k: 'A', v: 'Date Range', 's': EXCEL_BOLD }, { k: 'B', v: `${dateRange.startDate()} - ${dateRange.endDate()}` }],
                    })
                }

                rowsToAdd.push({
                    rowIndex: rowIndex++,
                    rowData: [{ k: 'A', v: 'Report Type', 's': EXCEL_BOLD }, { k: 'B', v: reportType }],
                })

                // Reverse sort the rows, so that we add lower row first
                // Final XML if rows in wrong order (not simple ascending order) will corrupt the Excel file
                rowsToAdd.sort((a,b) => b.rowIndex - a.rowIndex)

                // Add N + 1 more rows at top of table, N row and one empty row as separator
                this.excel_InsertEmptyRow(xlsx, 0, rowsToAdd.length + 1)

                // Write content of new rows
                rowsToAdd.forEach(row => {
                    this.excel_writeRowContent(xlsx, row.rowIndex, row.rowData)
                })

                // Styling of cell if needed, refer
                // https://datatables.net/reference/button/excelHtml5
                // https://codepen.io/RedJokingInn/pen/oYJbMP, if you want to customize the style sheet
                // var sheet = xlsx.xl.worksheets['sheet1.xml'];
                // $('row c', sheet).attr('s', '25');
                // $('row c[rc=2]', sheet).attr('s', '7');
            }
        }
    }

    // https://datatables.net/forums/discussion/36045/excel-export-add-rows-and-data/p2
    this.excel_InsertEmptyRow = (xlsx, rowIndex = 0, numberOfRow) => {
        console.log(xlsx);
        var sheet = xlsx.xl.worksheets['sheet1.xml'];

        var clRow = $('row', sheet)

        // Update Row
        let currentRow = -1 // So first currentRow++ will set it to 0

        const loopCellInThisRow = (row, callback) => {
            // Update  row > c
            $('row c', row).each(function () {
                callback(this)
            })
        }

        clRow.each(function () {
            currentRow++
            if (currentRow < rowIndex) {
                return
            }

            // attr = rowIndex, eg: 0,1,2,3...
            var attr = $(this).attr('r');
            var ind = parseInt(attr);
            ind = ind + numberOfRow;
            $(this).attr("r",ind);

            loopCellInThisRow(this, (cell) => {
                var attr = $(cell).attr('r');

                // pre = Column alphabet, eg: for cell A1, pre = "A"
                var pre = attr.substring(0, 1);

                // ind = Row number, eg: for cell A1, ind = "1"
                var ind = parseInt(attr.substring(1, attr.length));
                ind = ind + numberOfRow;
                $(cell).attr("r", pre + ind);
            })
        })
    }
    this.excel_writeRowContent = (xlsx, rowIndex, rowContent) => {
        let msg = '<row r="'+rowIndex+'">'
        for (let i = 0; i < rowContent.length; i++) {
            let key = rowContent[i].k;
            let value = rowContent[i].v;
            let style = rowContent[i].s ?? "";
            msg += '<c t="inlineStr" r="' + key + rowIndex + '" s="'+ style +'">';
            msg += '<is>';
            msg +=  '<t>'+value+'</t>';
            msg +=  '</is>';
            msg +='</c>';
        }
        msg += '</row>';

        var sheet = xlsx.xl.worksheets['sheet1.xml'];
        sheet.childNodes[0].childNodes[1].innerHTML = msg + sheet.childNodes[0].childNodes[1].innerHTML;
    }
    this.getDatatableButtonsOption = function(name, options) {
        let nameAndTitle = {
            filename: options.filename || (typeof name === 'function' ? name() : name),
            title: () => jsUcfirst(typeof name === 'function' ? name() : name)
        }
        let exportOptions = {
            columns: [ ':not(:first-child)', ':visible', '.exportable' ],
            stripNewlines: false,
        }

        let nameAndTitleAndExportOptions = {
            ... nameAndTitle,
            exportOptions: {... exportOptions},
        }

        // Flag to store whether has use clicked on
        // "Show All Columns"
        let allVisibleToggle = false
        let defaultHidden = null



        let buttons = [
            'copy',
            {
                ... nameAndTitleAndExportOptions,
                extend: 'csv',
                exportOptions: {
                    orthogonal: 'csv',
                    columns: [ '.exportable' ],
                },
                action: function(e, dt, node, config){
                    $.fn.dataTable.ext.buttons.csvHtml5.action.call(this, e, dt, node, config)
                },
                customize: options && options.customize && options.customize.csv,
            },
            {
                ... nameAndTitleAndExportOptions,
                extend: 'excel',
                exportOptions: {
                    orthogonal: 'excelHtml',
                    columns: [ '.exportable' ],
                    customizeData: options.excel && options.excel["customizeData"],
                },
                action: function(e, dt, node, config){
                    $.fn.dataTable.ext.buttons.excelHtml5.action.call(this, e, dt, node, config)
                },
                ...options.excel,
            },
            {
                ...nameAndTitle,
                // exportOptions: {
                //     ...nameAndTitleAndExportOptions.exportOptions,
                //     stripHtml: false,
                // },
                // exportOptions: false,
                extend: 'pdf',
                orientation: 'landscape',
                // exportOptions: {
                //     ...exportOptions,
                //     // stripHtml: true,
                // },
                exportOptions: {
                    columns: [ '.exportable' ],
                    orthogonal: 'export'
                },

                customize: function(doc) {
                    if (doc) {
                        for (var i = 1; i < doc.content[1].table.body.length; i++) {
                            const columnCount = doc.content[1].table.body[i].length
                            for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
                                var tmptext = doc.content[1].table.body[i][columnIndex].text;

                                if (tmptext.substr(0,11) == 'type=image:') {
                                    doc.content[1].table.body[i][columnIndex] = {
                                        margin: [0, 0, 0, 12],
                                        alignment: 'center',
                                        image: tmptext.substr(11),
                                        width: 60,
                                        height: 58
                                    };
                                }
                            }
                        }
                    }
                },
                action: function(e, dt, node, config){
                    $.fn.dataTable.ext.buttons.pdfHtml5.action.call(this, e, dt, node, config)
                }
            },
            {
                ... nameAndTitleAndExportOptions,
                extend: 'print',
                orientation: 'landscape',
                exportOptions: {
                    orthogonal: 'print',
                    columns: [ '.exportable' ],
                    stripHtml: false,
                },
                autoPrint: true,
                action: function(e, dt, node, config){
                    $.fn.dataTable.ext.buttons.print.action.call(this, e, dt, node, config)
                }
            },
        ]

        if (options && options.colvis) {
            buttons.push({
                text: 'Show All Columns',
                action: function ( e, dt, node, config ) {
                    if (defaultHidden === null) {
                        defaultHidden = []
                        let a = dt.columns().visible()
                        let keys = Object.keys(a)
                        keys.forEach((key) => {
                            if (!isNaN(key)) {
                                // Numeric key is the column visibilily
                                // 0: true, 1:false, 2: true, ...
                                if (!a[key]) {
                                    defaultHidden.push(parseInt(key))
                                }
                            }
                        })
                    }
                    let $button = $(e.target)
                    if (!allVisibleToggle) {
                        dt.columns().visible(true)
                        $button.html('Show Default Columns')
                    }
                    else {
                        dt.columns(defaultHidden).visible(false)
                        $button.html('Show All Columns')
                    }
                    allVisibleToggle = !allVisibleToggle
                }
            })
            buttons.push({
                extend: 'colvis',
                postfixButtons: [ 'colvisRestore' ]
            })
        }
        return buttons
    }
}

export var datatableHelper = new DatatableHelper();